import React from 'react';
import { createRoot } from 'react-dom/client';
import PredictionsLayout from '../components/predictions/PredictionsLayout.jsx';
import SetListPage from '../components/predictions/SetListPage.jsx';

const root = createRoot(document.getElementById('root'));
root.render(
  <PredictionsLayout>
    <SetListPage />
  </PredictionsLayout>
);
